export const BASE_URL = "https://idvapi.afritrack.com/api";
export const ASSETS_URL = "https://idvapi.afritrack.com";

// export const BASE_URL = "http://127.0.0.1:8000/api";
// export const ASSETS_URL = "http://127.0.0.1:8000";

export const COLORS = {
  BRAND: "#22578A",
  TRUE_RED: "#f41018",
  AFRITRACK_RED: "#e4040c",
  PALE_RED: "#f7bbbf",
  SEMI_PALE_RED: "#ec5a62",
  ORANGE: "#F68821",
  PALE_GREEN: "#d9fbd0",
  GREEN: "#1c6c09",
  GENERAL_BACKGROUND: "#FFFCE8",
  PALE_BLUE: "#3F88C5",
  GRAY: "#7c90a6",
  BLACK: "#0A0A08",
};
